import { Component, OnInit } from '@angular/core';
import {get as getCookie, remove as removeCookie, set as setCookie} from "es-cookie";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../shared/security/auth.service";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
  authInfo: AuthService;

  public booleanValues = [
    {value: false, display: 'Nee'},
    {value: true,  display: 'Ja'}
  ];
  setCookie: boolean;        // indicates if cookie with username/password will be set (unsafe)

  constructor(private fb: FormBuilder, private authService: AuthService,
              private router: Router, private translate: TranslateService) {

    this.authInfo = authService;
  }

  ngOnInit() {
  }

  public getTranslation(key: string) {
    let str="";
    this.translate.get(key).subscribe(value => {str = value});
    return str;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['home']);
  }

  cancelLogout() {
      this.router.navigate(['home']);
  }

}
